import Vue from 'vue'

import d2Container from './d2-container'

// 注意 有些组件使用异步加载会有影响
Vue.component('d2-container', d2Container)
Vue.component('linkyee-copyright', () => import('./Copyright'))
Vue.component('d2-icon', () => import('./d2-icon'))
Vue.component('d2-icon-svg', () => import('./d2-icon-svg/index.vue'))
Vue.component('linkyee-panel-counter', () => import('./linkyee-panel-counter'))
Vue.component('d2-ueditor', () => import('./d2-ueditor'))
Vue.component('d2-container-frame', () => import('./d2-container-frame/index.vue'))
Vue.component('no-privilege', () => import('./no-privilege'))

